import * as BBApi from '.';
const rootUrl: string = BBApi.host + '/hey-loyalty';

export async function getMemberLists(userId: number): Promise<Record<any, any>> {
	const response: Response = await BBApi.get(rootUrl + `/${userId}`);
	const memberLists: any[] = await response.json();
	return memberLists;
}

export async function deleteMember(userId: number) {
	const response: Response = await BBApi.del(rootUrl + `/${userId}`);
	const rejectedDeletions: any[] = await response.json();
	return rejectedDeletions;
}
